<template>
  <v-layout>
    <v-flex xs12 sm6 offset-sm3>
      <v-card>
        <v-img class="white--text" height="400px" src="/images/big-mac-extra-value-meal.jpg">
          <v-container fill-height fluid>
            <v-layout fill-height>
              <v-flex xs12 align-end flexbox>
              </v-flex>
            </v-layout>
          </v-container>
        </v-img>
        <v-card-title>
          <div>
            <span class="grey--text">Question 2</span>
            <br>
            <span>You and your brother get taken on a surprise trip to McDonalds. You both order a Big Mac Meal each. What is your strategy?</span>
          </div>
        </v-card-title>
        <v-card-text>
          <v-radio-group v-model="$store.question" :disabled="getShowAnswer">
            <v-radio
              @change="updateAnswer({value:$event,isCorrect:false})"
              label="Eat all your chips first, saving the Big Mac for last."
              value="Wrong: Your brother has demolished his big mac and is now moving onto yours despite your protest and cries for help from mum. Unlucky."
            ></v-radio>
            <v-radio
              @change="updateAnswer({value:$event,isCorrect:true})"
              label="Eat the Big Mac first, saving the chips for last."
              value="Correct: Now your brother can't steal your Big Mac."
            ></v-radio>
          </v-radio-group>
          <span v-if="getShowAnswer" >{{ getAnswer }}</span>
        </v-card-text>
        <v-card-actions>
          <v-btn v-if="getAnswer && !getShowAnswer" @click="showAnswer()" >Get Answer</v-btn>
          <v-btn v-if="getShowAnswer" to="/question3" flat color="orange">Next Question</v-btn>
          <v-spacer></v-spacer><span class="grey--text">Current score: {{getScore}}</span>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapMutations, mapGetters, store } from 'vuex';
export default {
  methods: mapMutations(['showAnswer', 'updateAnswer', 'nextQuestion']),
  computed: mapGetters(['getScore', 'getAnswer', 'getShowAnswer']),
  created() {
     this.$store.dispatch('resetQuestion');
   },
};
</script>